import React, { useState } from 'react';
import logo from '../assets/logo.png';

/**
 * Vorschau-Schutz: Passwort eingeben → Backend setzt Freischalt-Cookie.
 */
export default function SiteAccessGate({ onUnlock }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await onUnlock(password);
    } catch (err) {
      const msg = err.response?.data?.error || 'Hat nicht geklappt – Code nochmal prüfen?';
      setError(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
          <div className="px-8 pt-8 pb-6 border-b border-gray-100 flex flex-col items-center gap-4">
            <div className="bg-hrf-navy rounded-xl px-4 py-2.5">
              <img src={logo} alt="HR Factory" className="h-8 w-auto" />
            </div>
            <div className="text-center">
              <h1 className="text-xl font-semibold text-slate-800">Vorschau-Zugang</h1>
              <p className="text-sm text-slate-500 mt-1">
                Trag einfach den Zugangscode ein – dann geht’s weiter.
              </p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="px-8 py-7 space-y-5">
            {error && (
              <div className="rounded-lg bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700">
                {error}
              </div>
            )}

            <div className="space-y-1.5">
              <label className="block text-sm font-medium text-slate-700" htmlFor="site-access-pw">
                Zugangscode
              </label>
              <input
                id="site-access-pw"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-lg border border-gray-300 px-3.5 py-2.5 text-sm text-slate-900
                           placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-800
                           focus:border-transparent transition"
              />
            </div>

            <button
              type="submit"
              disabled={busy}
              className="w-full rounded-lg bg-hrf-navy text-white text-sm font-semibold py-2.5
                         hover:bg-hrf-navy-800 disabled:opacity-60 transition"
            >
              {busy ? 'Wird geprüft…' : 'Weiter'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
